export default __webpack_public_path__ + "static/media/achSampleCheck.daff79f6.png";